import { AppTheme } from './../../theme/useTheme';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: AppTheme) => ({
  button: {
    ...theme.typography.subtitle2,
    borderRadius: theme.spacing(3),
    textTransform: 'none',
  },
}));
